import React from 'react';
import { gengetURLTEST, genURL, genURLTEST } from '../../../_getjson';
import axios from 'axios';
import { DataGrid, GridToolbarQuickFilter, GridToolbar, } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

export default function SelectStkJobOrderSub(props) {

    const {
        multiselect,
        dataMain
    } = props
    const [loadingSub, setLoadingSub] = React.useState(true)
    const [data, setData] = React.useState([])
    const [selectionModel, setSelectionModel] = React.useState([]);

    const [state, setState] = React.useState({
        mainDocNo: ""
    });
    React.useEffect(() => {
        checkDocNo(dataMain)
        return () => {
        }
    }, [dataMain])

    React.useEffect(() => {
        if (state.mainDocNo != "") {
            getData(state.mainDocNo);
        }

        return () => {
        }
    }, [state.mainDocNo])

    const checkDocNo = async (val) => {
        let docNo = []

        await val.forEach(element => {
            // console.log("element", element) 
            docNo.push({ DocNo: element.DOCNO })
        });
        await setState((prevState) => ({
            ...prevState,
            mainDocNo: docNo
        }))

    }
    const getData = async (val) => {
        //   let rows = []
        await setLoadingSub(true)
        //   let url = `CSUNIT/All?`
        let url = genURL(`csstkjoborder/GetJobSubData?docno=` + JSON.stringify(val))
        console.log("url", url)
        await axios.get(url).then(res => {
            setData(res.data)

        })
        await setLoadingSub(false)
        //   await setData(rows)
    }

    const columns = [
        { field: "id", headerName: 'ID', width: 90, hide: false },
        {
            field: "DOCNO",
            headerName: 'ใบสั่งผลิต',
            width: 30,
            editable: false,
            flex: 1
        }, {
            field: 'PRODUCTCODE',
            headerName: 'รหัสวัตถุดิบ',
            width: 30,
            editable: false,
            flex: 1
        }, {
            field: 'PRODUCTNAME',
            headerName: 'ชื่อวัตถุดิบ',
            width: 200,
            editable: false,
            flex: 1
        },
        {
            field: 'UNITCODE',
            headerName: 'UNITCODE',
            width: 50,
            editable: false,
            hide: true,
            flex: 0
        },
        {
            field: 'UNITNAME',
            headerName: 'หน่วยนับ',
            width: 50,
            editable: false,
            flex: 1
        }, {
            field: 'QUANTITY',
            headerName: 'ปริมาณ',
            width: 50,
            editable: false,
            flex: 1
        }, {
            field: 'ROWORDER',
            headerName: 'ROWORDER',
            width: 50,
            editable: false,
            hide: true,
            flex: 0
        }, {
            field: 'REFDOCNO',
            headerName: 'REFDOCNO',
            width: 50,
            editable: false,
            hide: true,
            flex: 0
        }, {
            field: 'WAREHOUSE',
            headerName: 'WAREHOUSE',
            width: 50,
            hide: true,
            editable: false,
            flex: 0
        }, {
            field: 'LOCATION',
            headerName: 'LOCATION',
            width: 50,
            editable: false,
            hide: true,
            flex: 0
        }, {
            field: 'PRODUCTSET',
            headerName: 'PRODUCTSET',
            width: 50,
            editable: false,
            hide: true,
            flex: 0
        }, {
            field: 'PRODUCTSETCODE',
            headerName: 'PRODUCTSETCODE',
            width: 50,
            editable: false,
            hide: true,
            flex: 0
        }, {
            field: 'REFLINEID',
            headerName: 'REFLINEID',
            width: 50,
            editable: false,
            hide: true,
            flex: 0
        },
    ];

    const handleDoubleClick = (e) => {
        // console.log(selectionModel); 

        let result = []
        if (selectionModel.length > 0) {
            result = data.filter((elem) => {
                return selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        } else {
            result.push(e.row)
        }
        props.resultData(result)
    }
    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                }}
            >
                <GridToolbarQuickFilter />
            </Box>
        );
    }


    return (
        <>
            <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                {loading == true ? "กำลังโหลด..." :
                    <DataGrid
                        rows={data}
                        columns={columns}
                        sx={{
                            fontFamily: "Customfont !important"
                        }}
                        disableColumnFilter
                        disableColumnSelector
                        disableDensitySelector
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                            // filter: {
                            //     filterModel: {
                            //         items: [],
                            //         quickFilterValues: ['quick', 'filter'],
                            //     },
                            // },
                        }}
                        pageSizeOptions={[10]}
                        checkboxSelection={multiselect}
                        disableSelectionOnClick
                        onSelectionModelChange={(newSelectionModel) => {
                            setSelectionModel(newSelectionModel);
                        }}
                        selectionModel={selectionModel}
                        onRowDoubleClick={e => handleDoubleClick(e)}
                        //  onRowClick={e => handleClick(e)}
                        components={{ Toolbar: QuickSearchToolbar }}
                    />}
            </Box>
        </>
    )

}
SelectStkJobOrderSub.propTypes = { multiselect: PropTypes.bool, }
SelectStkJobOrderSub.defaultProps = {
    multiselect: false
};